import { z } from "zod";

export const fieldDefinitionSchema = z.object({
  entityType: z.enum(["asset", "accessory"]).default("asset"),
  categoryCode: z.string().trim().max(50).optional().nullable(),
  code: z
    .string()
    .trim()
    .regex(/^[a-z][a-z0-9_]{1,40}$/, "编码需为小写字母开头"),
  name: z.string().trim().min(1).max(80),
  dataType: z.enum(["text", "number", "date", "boolean", "select"]).default("text"),
  required: z.boolean().default(false),
  options: z.array(z.string().trim().min(1).max(100)).max(100).default([]),
  displayOrder: z.coerce.number().int().min(0).max(9999).default(0),
  groupName: z.string().trim().max(50).optional().nullable(),
  isActive: z.boolean().default(true),
});

export const fieldDefinitionUpdateSchema = fieldDefinitionSchema.partial().extend({
  id: z.string().min(1),
});

export const assetFieldValuesSchema = z.object({
  values: z
    .array(
      z.object({
        definitionId: z.string().min(1),
        value: z.union([z.string(), z.number(), z.boolean(), z.null()]),
      }),
    )
    .max(100),
});
